export interface Filters {
    min : string | null,
    max : string | null,
    isMonthlyView : boolean;
}
export interface ISeTimelineFeatureState {
    patientId : string; // paziente di cui si carica la storia
    selectedItem : any; // Elemento della storia selezionato
}

export interface ISeTimelineDataState {
    data : any[];
    filters?: Filters;
}

export interface ISeTimelineReportState {
    report: any[];
    filters?: Filters;
}

export interface SeTimelineState {
    feature : ISeTimelineFeatureState;
    clinicalHistory: ISeTimelineDataState;
    reportHistory: ISeTimelineReportState;
}

export const seTimelineInitialState : SeTimelineState = {
    feature: {
        patientId: '',
        selectedItem: null
    },
    clinicalHistory: {
        data: [],
        filters: {
            min: null,
            max: null,
            isMonthlyView: false
        }
    },
    reportHistory: {
        report: [],
        filters: {
            min: null,
            max: null,
            isMonthlyView: false
        }
    }
};
